import React from 'react';
import { Route } from 'react-router-dom';
import { URL, TYPE } from '../../../constant';
import MathpixView from '../../ocr/rcmndLearning/MathpixView';
import ConceptCheckPlayer from '../ConceptCheckPlayer';
import CheckWrongAnswer from './CheckWrongAnswer';

function IframeArea() {
  return (
    <Route path={ URL.IFRAME.I }>
      <Route exact path={ URL.IFRAME.CHECK_CONCEPT }>
        <div className={ TYPE.DEVICE.PC }>
          <ConceptCheckPlayer />
        </div>
      </Route>
      <Route exact path={ URL.IFRAME.CHECK_WRONG_ANSWER }>
        <CheckWrongAnswer />
      </Route>
      <Route exact path={URL.IFRAME.OCR_MATHPIX}>
        <MathpixView />
      </Route>
    </Route>
  );
}

export default IframeArea;